import { render, staticRenderFns } from "./EditorMemos.vue?vue&type=template&id=2b6977ce&scoped=true"
import script from "./EditorMemos.vue?vue&type=script&lang=js"
export * from "./EditorMemos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6977ce",
  null
  
)

export default component.exports